// "See it as a member" on a paid product: staff without the product can't open its pages, so this
// picks someone who has it and views as them (hub.start_view_as, read only and audited), opening the
// product's own page as they see it. Owner and admin; an owner for a member of staff. No board draws
// the picker; the words are in the stage 5 batch.
import { Dialog, ButtonLink, StatusPill, Loading, Problem, useLoad, adminPath } from '../ui/index.js'
import { useViewAs } from '../../lib/viewAs.jsx'
import { SEE_AS } from './copy.js'
import { firstNameOf } from './model.js'

const STATUS_WORDS = { active: 'Active', overdue: 'Overdue', suspended: 'Suspended', paused: 'Paused', secured: 'Place secured' }

export function SeeAsDialog({ api, product, clients, onClose }) {
  const viewAs = useViewAs()
  const draft = product.state !== 'live'
  const people = useLoad(async () => {
    if (draft) return []
    // a 1-2-1's clients are its open spaces, already on the page
    if (product.type === 'client_space') return clients.map(c => ({ id: c.id, full_name: c.full_name, first_name: c.first_name, role: null, status: 'active' }))
    const rows = await api.staff_people({ product: product.id, status_group: 'active', limit: 6 })
    return rows.map(r => ({ id: r.person_id, full_name: r.full_name, role: r.role, email: r.email, status: r.status_key }))
  }, [product.id, draft])
  const list = people.status === 'ready' ? people.data.filter(p => viewAs.canViewAs(p)) : []

  return (
    <Dialog title={SEE_AS.title(product.name)} onClose={onClose} busy={viewAs.busy}
      footer={<ButtonLink to={adminPath.people()} size="sm">{SEE_AS.people}</ButtonLink>}>
      {draft ? <p className="ad-lede">{SEE_AS.draft(product.name)}</p> : (
        <>
          <p className="ad-lede">{SEE_AS.line}</p>
          {people.status === 'loading' && <Loading>{SEE_AS.loading}</Loading>}
          {people.status === 'error' && <Problem error={people.error} onRetry={people.reload} />}
          {people.status === 'ready' && !list.length && <p className="ad-empty ap-see-empty">{SEE_AS.nobody}</p>}
          {list.length > 0 && (
            <ul className="ap-see-list">
              {list.map(p => (
                <li key={p.id} className="ap-see-row">
                  <span className="ap-see-who">
                    <span className="ap-see-name">{p.full_name}</span>
                    {p.email && <span className="ap-see-email">{p.email}</span>}
                  </span>
                  {STATUS_WORDS[p.status] && <StatusPill status={p.status}>{STATUS_WORDS[p.status]}</StatusPill>}
                  <button type="button" className="ad-btn ad-btn--line ad-btn--sm" disabled={viewAs.busy}
                    onClick={() => viewAs.start(p, { to: product.path || '/' })}>
                    {SEE_AS.viewAs(firstNameOf(p) || 'member')}
                  </button>
                </li>
              ))}
            </ul>
          )}
          {viewAs.error && <p className="ad-error" role="alert">{viewAs.error}</p>}
        </>
      )}
    </Dialog>
  )
}
